// extracted by mini-css-extract-plugin
export default {"container":"orderedParts_container__sj+Nw"};